<div *ngIf="noAccess && isMobileScreen" class="empty-state no-access" [ngStyle]="emptyStateBackground">
    <div class="mobile-no-access-header">
        <vnc-mobile-header
            headerType="dark-back-more"
            darkBackMorePlaceHolder=""
            (darkBackPress)="backToChannelTab()"
        ></vnc-mobile-header>
    </div>
    <vnc-empty-state [selectedChannel]="channel" [iconTemplate]="emptyStateIconTemplate"
      title="{{ 'YOU_NEED_PERMISSION' | translate }}" description="{{ 'YOU_NEED_PERMISSION_TOPIC_DESC' | translate }}"
      buttonText="{{ 'REQUEST_ACCESS' | translate }}" type="{{ emptyStateTypeNoAccess }}"
      (buttonClicked)="requestAccess()"></vnc-empty-state>
</div>
<div id="mobile_topic_detail_body" class="mobile-topic-detail-component vnc-scroll-bar--small--vertical" *ngIf="isMobileScreen && !noAccess" vpInfiniteScroll scrollPercentage="1" (onUserScroll)="loadMoreComments()">
  <div *ngIf="topic?.deleted || topic?.archived" class="restore-banner-wrapper"
       [ngClass]="{'disable-restore':  !topic?.permissions || topic?.permissions?.length <= 0 || !topic?.permissions[0] || !topic?.permissions[0]?.deletable}">
    <vnc-banner class="restore-banner"
      [type]="'text-3-actions'"
      labelText="{{ this.bannerMsg | translate }}"
      [actionLinkLabel3]="this.bannerActionLabel | translate | lowercase"
      (actionLink3Clicked)="unarchiveTopic(topic)"
      (click)="goBackToTrashOrArchive($event, {trash: topic?.deleted, archive: topic?.archived})"
    ></vnc-banner>
  </div>

  <div *ngIf="topicRestored || topicUnarchived" class="success-restore-banner-wrapper">

    <vnc-banner class="success-restore-banner"
                [type]="'back-close'"
                (backClicked)="goBackToTrashOrArchive($event, {trash: topicRestored, archive: topicUnarchived})"
                [labelText]="this.restoreBannerLabel | translate"
                [color]="'green'">
    </vnc-banner>
  </div>
  <div *ngIf="!noAccess && topic?.is_scheduled" class="topic-schedule-stripe">
    <vnc-banner
        [type]="'text-3-actions'"
        labelText="{{ 'SCHEDULE_PUBLISH_DATE' | translate }} {{ topic?.publish_at | date:'dd MMMM yyyy'}}"
        actionLinkLabel2=" "
        actionLinkLabel3=" "
        actionLinkLabel1=" "
        [actionLink1IconTemplate]="cloneIcon"
        [actionLink2IconTemplate]="scheduleIcon"
        [actionLink3IconTemplate]="editIconWhite"
        color="green"
        (actionLink2Clicked)="editScheduleTopic()"
        (actionLink3Clicked)="editTopic()"
        (actionLink1Clicked)="cloneTopic()"
    ></vnc-banner>
  </div>
  <div *ngIf="!noAccess && topic?.is_draft" class="topic-draft-stripe">
    <vnc-banner
        [type]="'text-3-actions'"
        labelText="{{ 'DRAFT' | translate }}"
        actionLinkLabel2=" "
        actionLinkLabel3=" "
        actionLinkLabel1=" "
        [actionLink1IconTemplate]="cloneIcon"
        [actionLink2IconTemplate]="scheduleIcon"
        [actionLink3IconTemplate]="editIconWhite"
        color="green"
        (actionLink1Clicked)="cloneTopic()"
        (actionLink2Clicked)="publishDraftTopic()"
        (actionLink3Clicked)="editTopic()"
    ></vnc-banner>
  </div>
  <vnc-mobile-tile-component
    [type]="'video'"
    [unread_comments_count]="topic?.unread_comments_count"
    [comments_count]="topic?.comments_count"
    [item]="getItem(topic)"
    [coverImageURL]="getCoverImgURL(topic)"
    [description]="topic?.subject"
    (iconPress)="iconPress($event)"
    [menuTemplate]="menuTopicDetailTemplate"
    [menuItem]="topic"
    [headerLable]="topic?.subject"
    (like)="mobileLikeUnlike()"
    [liked]="topic?.liked"
    [isShowPlayButton]="isShowPlayIcon(topic)"
    [likes_count]="topic?.likes_count"
    (comment)="addComment()"
    (isShowPlayButtonImgType) = "true"
    [badgeType]="topic?.topic_type === 'regular' ? 'topic-regular' : (topic?.topic_type === 'analytics' ?  'analytics-topic' : 'video-topic')"
    (playButtonPress)="playMobileVideoFromCover(topic)"
  ></vnc-mobile-tile-component>

  <!--Video type Videos-->
  <div class="mobile-topic-video" *ngIf="!!video || !!embeddedVideoLink">
    <ng-container *ngIf="!!video">
        <video controls preload="auto" #mobileTopicVideoPlayer
               [poster]= "defaultThumbnail?.thumbnail_url || video?.thumbnail_url"
               (ended)="videoEnded()">
            <source [src]="video?.content_url" [type]="video?.content_type">
        </video>
    </ng-container>
    <ng-container *ngIf="!!embeddedVideoLink">
      <div class="iframe-wrapper">
        <video [poster]="'https://img.youtube.com/vi/'+getVideoId(embeddedVideoLink)+'/0.jpg'"></video>
        <vnc-play-button id="iframe-play" [size]="'l'" [state]="videoPlayState" (click)="playYoutube('https://youtube.com/watch?v='+getVideoId(embeddedVideoLink))"></vnc-play-button>
      </div>
        <div class="iframe-wrapper" *ngIf="!embeddedVideoHTML">
            <iframe [src]="sanitizedEmbeddedVideoLink" width="100%" height="100%">
            </iframe>
        </div>
    </ng-container>
 </div>
 <!--End Video type Videos-->

  <div class="description ql-editor"
       (click)="onTopicDetailClick($event, true)"
       [innerHTML]="topic?.description | vpSafeHtml"></div>
  <div *ngIf="($topicFiles | async)?.length > 0" class="attachment-list">
    <vnc-files-preview
      [filesCount]="($topicFiles | async)?.length"
      [files]="$topicFiles | async"
      [removeText]=""
      attachmentText="{{'ATTACHES' | translate }}"
      downloadText="{{'DOWNLOAD' | translate }}"
      copyLinkText="{{'COPY_LINK' | translate }}"
      copyFileToClipboardText="{{'COPY_FILE_TO_CLIPBOARD' | translate }}"
      (downloadAllFiles)="downloadFiles($event, true)"
      (downloadFile)="downloadFiles([$event])"
      (copyFileLink)="copyFileLink($event)"
      (fileItemClicked)="fileItemClicked($topicFiles.getValue(), $event)"
      (copyFileToClipboard)="copyFilesToClipboard([$event])"
      moreText="{{'MORE_TEXT' | translate }}"
    >
    </vnc-files-preview>
  </div>
  <div *ngIf="topic?.tags && topic?.tags.length > 0" class="tag-chips">
    <div class="tag-text-lbl">{{ 'TAGS' | translate }}</div>
    <div class="tags-item">
      <div class="chips-item" *ngFor="let tag of topic?.tags">
        <vnc-chips [text]="tag?.name" type="filter" size="m">
        </vnc-chips>
      </div>
    </div>
  </div>

  <div class="mobile-social-media-icons_topic-detail">
    <span class="social-media-icons-heading">{{'LIKE_TOPIC_SHARE_WITH_FRIENDS' | translate}}</span><br>
    <span class="social-media-icons-heading-item">{{'SHARE_TOPIC' | translate}}</span>

    <ul class="
    social-media-icons_topic-detail-list">
      <li class="social-media-icons_topic-detail-list-item"><svg (click)="socialSharing('https://twitter.com/intent/tweet?url='+topicURL+'&text= Check out this amazing topic at VNC')" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm2.692 7.01c.827 0 1.572.336 2.096.876a5.917 5.917 0 0 0 1.825-.674 2.804 2.804 0 0 1-1.262 1.534A5.896 5.896 0 0 0 19 8.309c-.33.476-.735.903-1.2 1.26l-.236.173.01.359c0 3.664-2.889 7.89-8.172 7.89A8.33 8.33 0 0 1 5 16.742c.225.024.453.038.685.038a5.894 5.894 0 0 0 3.567-1.186c-1.257-.021-2.317-.823-2.683-1.925a3.007 3.007 0 0 0 1.297-.046c-1.255-.244-2.216-1.28-2.297-2.545l-.006-.209c.388.208.83.333 1.301.348A2.748 2.748 0 0 1 5.587 8.91c0-.508.14-.985.388-1.393a8.253 8.253 0 0 0 5.92 2.897 2.69 2.69 0 0 1-.075-.632c0-1.53 1.286-2.772 2.872-2.772z" fill="#1DA1F2" fill-rule="evenodd"/>
    </svg></li>
      <li class="social-media-icons_topic-detail-list-item"><svg (click)="socialSharing('https://www.facebook.com/sharer/sharer.php?u='+topicURL+'&amp;src=sdkpreparse')" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm3 5h-1.867C10.8 5 9.867 6.54 9.867 8.267v1.4H8V12h1.867v7h2.8v-7h2.053L15 9.667h-2.333v-1.4c0-.607.14-.934 1.12-.934H15V5z" fill="#4267B2" fill-rule="evenodd"/>
    </svg></li>
      <li class="social-media-icons_topic-detail-list-item"><svg (click)="linkdlnShare(topicURL)" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zM8.342 9.65c-.662.007-1.331.007-1.993 0-.126 0-.168.035-.168.168v7.091c0 .133.035.168.16.168.67-.007 1.34-.007 2.001 0 .126 0 .168-.035.168-.16-.007-1.183-.007-2.365-.007-3.546V9.762c-.008-.082-.05-.112-.16-.112zm7.348.091a3.189 3.189 0 0 0-2.085-.175 2.42 2.42 0 0 0-1.464 1.035c0-.258-.007-.524 0-.783.007-.119-.034-.168-.16-.168-.641.007-1.283.007-1.924 0-.111 0-.16.035-.16.161.007 2.37.007 4.741 0 7.105 0 .126.042.16.16.16a96.74 96.74 0 0 1 2.015 0c.118 0 .153-.034.153-.16a274.363 274.363 0 0 1 0-3.37c0-.28.021-.56.049-.833.042-.307.132-.587.348-.818.265-.294.62-.363.997-.357.537.014.865.26 1.018.77.098.328.105.664.105 1v3.594c0 .168.007.175.167.175h2.028c.14-.003.14-.025.14-.203l-.021-4.35a4.91 4.91 0 0 0-.188-1.314c-.181-.658-.53-1.189-1.178-1.469zm-8.352-3.74C6.544 6.006 6.007 6.642 6 7.35c0 .734.606 1.356 1.345 1.35.76-.008 1.346-.581 1.346-1.35 0-.784-.6-1.357-1.353-1.35z" fill="#2867B2" fill-rule="evenodd"/>
    </svg></li>
      <li class="social-media-icons_topic-detail-list-item"><svg (click)="shareViaEmail('mailto:?subject= Check out this amazing topic '+ topic?.subject + ' by ' + topic?.author?.name  + ' at VNC '+ topicURL +'&amp;body= Check out this amazing topic '+ topic?.subject + ' by ' + topic?.author?.name +  ' at VNC '+ topicURL)" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h14zm.774 2.367-5.653 5.654a3 3 0 0 1-4.242 0L4.226 6.367a.995.995 0 0 0-.22.516L4 7v10a1 1 0 0 0 .883.993L5 18h14a1 1 0 0 0 .993-.883L20 17V7c0-.24-.085-.46-.226-.633zM17.314 6H6.685l4.608 4.607a1 1 0 0 0 1.327.077l.087-.077L17.314 6z" fill="#8B96A0" fill-rule="nonzero"/>
    </svg></li>
      <li class="social-media-icons_topic-detail-list-item"><svg (click)="copyTopicLink(item)" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 5c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2zm0 2H8v14h11V7zm-4.064-5a1 1 0 0 1 .117 1.993L14.936 4H7.333c-1.235 0-2.246.96-2.328 2.174L5 6.334v11.683a1 1 0 0 1-1.993.116L3 18.017V6.333a4.333 4.333 0 0 1 4.123-4.328L7.333 2h7.603z" fill="#8B96A0" fill-rule="nonzero"/>
    </svg></li>
    </ul>
  </div>

  <div class="topic-comment-part">
    <div *ngIf="!noAccess && !topic?.comments_disabled" class="topic-detail_comments">
      <vp-comments [topicId]="topicId" [comment_count]="topic?.comments_count !== null ? topic.comments_count : 0" [focusOnCreation]="focusToCommentArea" (onFormClear)="onCommentFormClear()"></vp-comments>
      <vnc-spinner [size]="'xs'" *ngIf="commentsLoading"></vnc-spinner>
    </div>
    <div *ngIf="!noAccess && topic?.comments_disabled" class="comment-info">
        <span class="disable-text">{{ 'COMMENTS_DISABLE_MSG' | translate }}</span>
    </div>
  </div>
</div>

<div class="desktop-topic-detail-component" *ngIf="!isMobileScreen">
  <div style="position: absolute;width: 100%;z-index: 10000;top: 52px;"><vnc-banner type="next-message" [labelText]="currentHighlightedIndex+' / '+ totalHighLights" (actionClicked)="onSearchMatchNavigation($event)" [color]="'green'" *ngIf="totalHighLights"></vnc-banner></div>
  <div class="topic-detail__wrapper vnc-scroll-bar--small--vertical">
    <div *ngIf="noAccess" class="empty-state no-access" [ngStyle]="emptyStateBackground">
      <vnc-empty-state [iconTemplate]="emptyStateIconTemplate"
                       title="{{ 'YOU_NEED_PERMISSION' | translate }}"
                       [selectedChannel]="channel"
                       description="{{ 'YOU_NEED_PERMISSION_TOPIC_DESC' | translate }}"
                       buttonText="{{ 'REQUEST_ACCESS' | translate }}"
                       type="{{ emptyStateTypeNoAccess }}"
                       (buttonClicked)="requestAccess()"></vnc-empty-state>
    </div>

      <div *ngIf="!noAccess" class="topic-detail__header">
          <div class="topic-detail__header__left">
              <div>
                  <mat-icon (click)="backToChannel()" class="mdi-24px" fontSet="mdi" fontIcon="mdi-arrow-left"></mat-icon>
              </div>
              <div class="channel-info"  (click)="backToChannel()">
                  <div class="channel-name" [class.align-center]="!selectedChannel?.description">
                      {{ selectedChannel?.name }}
                      <div class="mute-icon">
                        <vnc-action-panel   *ngIf="!selectedChannel?.archived && !selectedChannel?.deleted && !selectedChannel?.muted" (actionClicked)="muteChannel(selectedChannel)" [iconTemplate]="muteIconBlack" [type]="'action'" [actionColor]="'white'" matTooltip="{{ 'MUTE_CHANNEL' | translate }}" matTooltipPosition="below" matTooltipClass="customise-tooltip"></vnc-action-panel>
                        <vnc-action-panel *ngIf="!selectedChannel?.archived && !selectedChannel?.deleted && selectedChannel?.muted" (actionClicked)="unmuteChannel(selectedChannel)" [iconTemplate]="unmuteIconBlack" [type]="'action'" [actionColor]="'white'" matTooltip="{{ 'UNMUTE_CHANNEL' | translate }}" matTooltipPosition="below" matTooltipClass="customise-tooltip"></vnc-action-panel>  
                      </div>
                  </div>
                  <div *ngIf="selectedChannel?.last_posted_on" class="channel-description">
                      {{ getLastPostTime(selectedChannel?.last_posted_on) }}
                  </div>
                  <div *ngIf="!selectedChannel?.last_posted_on && selectedChannel?.updated_on" class="channel-description">
                    {{getLastPostTime(selectedChannel?.updated_on)}}
                  </div>
              </div>
          </div>
        <div class="topic-detail__header__right" *ngIf="topic?.archived  && topic?.permissions && topic?.permissions?.length > 0 && topic?.permissions[1] && topic?.permissions[1]?.editable">
           <button (click)="unarchiveTopic(topic)" mat-button>{{'UNARCHIVE' | translate}}</button>
        </div>
      </div>
      <div *ngIf="!noAccess" class="topic-detail-with-comments vnc-scroll-bar--medium--vertical"
      vpInfiniteScroll
      scrollPercentage="1"
      (onUserScroll)="loadMoreComments()"
      >
        <div *ngIf="!noAccess && topic?.is_scheduled" class="topic-schedule-stripe">
          <vnc-banner
              [type]="'text-3-actions'"
              labelText="{{ 'SCHEDULE_PUBLISH_DATE' | translate }} {{ topic?.publish_at | date:'dd MMMM yyyy'}}"
              actionLinkLabel2="{{ 'EDIT_SCHEDULE' | translate }}"
              actionLinkLabel3="{{ 'EDIT_LBL' | translate }}"
              actionLinkLabel1="{{ 'CLONE' | translate }}"
              [actionLink1IconTemplate]="cloneIcon"
              [actionLink2IconTemplate]="scheduleIcon"
              [actionLink3IconTemplate]="editIconWhite"
              color="green"
              (actionLink2Clicked)="editScheduleTopic()"
              (actionLink3Clicked)="editTopic()"
              (actionLink1Clicked)="cloneTopic()"
          ></vnc-banner>
        </div>
        <div *ngIf="!noAccess && topic?.is_draft" class="topic-draft-stripe">
          <vnc-banner
              [type]="'text-3-actions'"
              labelText="{{ 'DRAFT' | translate }}"
              actionLinkLabel1="{{ 'CLONE' | translate }}"
              actionLinkLabel2="{{ 'PUBLISH' | translate }}"
              actionLinkLabel3="{{ 'EDIT_LBL' | translate }}"
              [actionLink1IconTemplate]="cloneIcon"
              [actionLink2IconTemplate]="scheduleIcon"
              [actionLink3IconTemplate]="editIconWhite"
              color="green"
              (actionLink1Clicked)="cloneTopic()"
              (actionLink2Clicked)="publishDraftTopic()"
              (actionLink3Clicked)="editTopic()"
          ></vnc-banner>
        </div>
        <div class="sub-header">
          <vnc-banner [type]="'text-close'"
                      class="go-to-parent-banner"
                      *ngIf="$showGoToParentBanner | async"
                      [color]="'green'"
                      (click)="goToParentActionClick($event)"
                      (actionClicked)="dismissGotoBanner()"
                      labelText="{{'GO_BACK_TO_PARENT_TOPIC' | translate}}"></vnc-banner>
          <vnc-banner [type]="'back-close'"
                      *ngIf="topic?.archived"
                      style="margin-bottom: 12px;"
                      (backClicked)="goBack('archive-topics')"
                      class="unclosable-banner"
                      labelText="{{'ARCHIVED_TOPIC' | translate}}"></vnc-banner>
          <vnc-banner [type]="'back-close'"
                      *ngIf="topic?.deleted"
                      style="margin-bottom: 12px;"
                      (backClicked)="goBack('trash-topics')"
                      class="unclosable-banner"
                      labelText="{{'TRASHED_TOPIC' | translate}}"></vnc-banner>
          <vnc-banner [type]="'back-close'"
                      style="margin-bottom: 12px;"
                      class="unclosable-banner"
                      *ngIf="!topic?.archived && selectedChannel?.archived"
                      labelText="{{'TOPIC_PART_OF_ARCHIVED_CHANNEL' | translate}}"></vnc-banner>
          <vnc-banner [type]="'back-close'"
                      class="unclosable-banner"
                      (backClicked)="goBack('archive-topics')"
                      *ngIf="topic?.archived && selectedChannel?.archived"
                      labelText="{{'TOPIC_ARCHIVED_AND_PART_OF_ARCHIVED_CHANNEL' | translate}}"></vnc-banner>
          <vnc-banner [type]="'back-close'"
                      style="margin-bottom: 12px;"
                      class="unclosable-banner"
                      *ngIf="!topic?.deleted && selectedChannel?.deleted"
                      labelText="{{'TOPIC_PART_OF_TRASHED_CHANNEL' | translate}}"></vnc-banner>
          <vnc-banner [type]="'back-close'"
                      class="unclosable-banner"
                      (backClicked)="goBack('trash-topics')"
                      *ngIf="topic?.deleted && selectedChannel?.deleted"
                      labelText="{{'TOPIC_TRASHED_AND_PART_OF_TRASHED_CHANNEL' | translate}}"></vnc-banner>
                      
          <vnc-banner *ngIf="!topic?.archived && showUnarchivedBanner" [type]="'text-close'"
                      [color]="'green'" (actionClicked)="toggleUnarchivedBanner()" [labelText]="'TOPIC_SUCCESSFULLY_UNARCHIVED' | translate"></vnc-banner>
        </div>
        <vnc-banner style="width:100%; position: absolute; top: 0; z-index: 10;" [type]="'text-loader'" labelText="{{totalFilesUploading}} {{(totalFilesUploading > 1 ? 'FILES_UPLOADING' : 'FILE_UPLOADING') | translate}}"
                    *ngIf="isUploadRunning"></vnc-banner>
        <vnc-banner style="width:100%; position: absolute; top: 0; z-index: 10;"
                    *ngIf="!isUploadRunning && showSuccessBanner" (click)="showNewUploadedFiles()"
                    [type]="'text-close'" [color]="'green'" (actionClicked)="dismissSuccessBanner()" [labelText]="'FILES_UPLOADED' | translate"></vnc-banner>

        <div  class="topic-detail_hero" *ngIf="(topic?.topic_type !== 'video' && ((heroAttachments?.length > 0) || (!!topic?.default_cover_url)))">
          <vnc-hero-image
            *ngIf="(heroAttachments && heroAttachments.length > 0)"
            (heroImageClicked)="heroImageClicked($event)"
            height="360px" [attachments]="heroAttachments" [thumbnailSize]="800"
            ></vnc-hero-image>
          <img
            *ngIf="!(heroAttachments && heroAttachments.length > 0)"
            class="default-cover-image" [src]="topic?.default_cover_url">
        </div>
        <div *ngIf="topic && shouldShowDesc" class="topic-detail_info" [class.hero-header]="topic?.topic_type !== 'video' && (heroAttachments?.length > 0)" id="topic_detail_body">
          <ng-template #avatarTemplate>
              <vnc-avatar [ngClass]="{'inactive-vnc-avatar': !topic?.author?.active}" customSize="88px" [imgSrc]="topic?.author?.avatar_url" [defaultAvatar]="defaultAvatar"></vnc-avatar>
          </ng-template>
          <vnc-topic-detail [ngClass]="{'is-liked': topic?.liked}" [avatarTemplate]="avatarTemplate" [menuTemplate]="menuTemplate" [menuWidth]="300" [item]="topic"
                            [itemCreated]="getDateTimeInFormat(topic)"
                            [permitEditTag]="topic?.permissions && topic?.permissions?.length > 0 && topic?.permissions[1] && topic?.permissions[1]?.editable"
                            [removeTagTemplate]="removeTagTemplate"
                            commentText="{{ (topic?.comments_count === 1 ? 'COMMENT' : 'COMMENTS') | translate }}" noCommentText="{{ 'NO_COMMENTS' | translate }}"
                            forwardText="{{ 'FORWARD' | translate }}" filesText="{{ (topicFilesInfo?.totalCount === 1 ? 'FILE' : 'FILES') | translate }}"
                            moreText="{{ 'MORE_TEXT' | translate }}" relatedTopicText="{{ (topic?.related_topics?.length === 1 ? 'RELATION' : 'RELATIONS') | translate }}"
                            chartText="{{'CHART'| translate}}"
                            (moveToComment)="openCommentForm()"
                            (moveToRelatedTopics)="openRelatedTopicSection()"
                            [files]="$topicFiles | async"
                            [filesCount]="topicFilesInfo?.totalCount || 0"
                            noContentToDisplayText="{{'NO_CONTENT_TO_DISPLAY'|translate}}"
                            attachmentText="{{'ATTACHES' | translate }}"
                            downloadText="{{'DOWNLOAD' | translate }}"
                            copyLinkText="{{'COPY_LINK' | translate }}"
                            removeText="{{'REMOVE' | translate }}"
                            fileCountLabel="{{'FILES' | translate}}"
                            subscribedIconText="{{'SUBSCRIBED_TO_THE_TOPIC' | translate}}"
                            removeAllText="{{'ALL_REMOVE' | translate}}"
                            copyFileToClipboardText="{{'COPY_FILE_TO_CLIPBOARD' | translate }}"
                            (likeClicked)="likesTopic($event)" (forwardItem)="openSendTopicLinkPopup($event)"
                            (openFiles)="openTopicFiles($event)"
                            (copyAllFilesToClipboard)="copyFilesToClipboard($event, true)"
                            (removeAllFiles)="removeAllAttachments($event)"
                            (downloadAllFiles)="downloadFiles($event, true)"
                            (downloadFile)="downloadFiles([$event])"
                            (copyFileLink)="copyFileLink($event)"
                            (toggleMinimizeState)="updateReferenceIndices(true)"
                            [showLoadMoreButton]="topicFilesInfo.totalCount > topicFilesLength"
                            (onLoadMoreClicked)="fetchMoreTopicFiles()"
                            [loadMoreText]="'LOAD_MORE' | translate"
                            [loadingText]="'LOADING' | translate"
                            [createText]="'CREATED' | translate"
                            likesText="{{ (topic?.likes_count === 1 ? 'LIKE' : 'LIKES') | translate }}"
                            [tagsText]="'TAGS' | translate"
                            [emptyTagsText]="'NO_TAGS_TOPIC' | translate"
                            [fileLoading]="($fetchingMoreFiles | async) === true"
                            (copyFileToClipboard)="copyFilesToClipboard([$event])"
                            (mouseover)="onTopicDetailHover($event)"
                            (click)="onTopicDetailClick($event)"
                            (moveToCommentItems)="moveToComment()"
                            [linkify]="true"
                            [remarks]="remarks"
                            (fileItemClicked)="fileItemClicked($topicFiles.getValue(), $event)"
                            (removeAllAttachments) = "removeAllAttachments($event)"
                            (removeAllTags) = "removeAllTags($event)"
                            (removeFile) = "removeAttachment($event)"
                            [relatedTopicsTemplate]="relatedTopicsTemplate"
                            (goToRemark)="remarkClicked($event)"
                            [isAnalyticsTopic]="topic?.topic_type === 'analytics'"
                            [maximizeText]="'MAXIMIZE' | translate"
                            [minimizeText]="'MINIMIZE' | translate"
                            remarksText="{{(remarks?.length > 1 ? 'REFERENCES' : 'REFERENCE') | translate }}"
          ></vnc-topic-detail>

          <div class="web-social-media-icons_topic-detail">
            <span class="social-media-icons-heading">{{'LIKE_TOPIC_SHARE_WITH_FRIENDS' | translate}}</span><br>
            <span class="social-media-icons-heading-item">{{'SHARE_TOPIC' | translate}}</span>

            <div class="social-media-icons_topic-detail-list">
              <div class="social-media-icons_topic-detail-list-item" [matTooltip]="'SHARE_ON_X' | translate" [matTooltipPosition]="'above'" [matTooltipClass]="'social-media-tooltips'">
                <svg (click)="socialSharing('https://twitter.com/intent/tweet?url='+topicURL+'&text= Check out this amazing topic at VNC')" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" width="24px" height="24px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><path d="M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z"/></svg>
              </div>
              <div class="social-media-icons_topic-detail-list-item" [matTooltip]="'SHARE_ON_FACEBOOK' | translate" [matTooltipPosition]="'above'" [matTooltipClass]="'social-media-tooltips'"><svg (click)="socialSharing('https://www.facebook.com/sharer/sharer.php?u='+topicURL+'&amp;src=sdkpreparse')" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm3 5h-1.867C10.8 5 9.867 6.54 9.867 8.267v1.4H8V12h1.867v7h2.8v-7h2.053L15 9.667h-2.333v-1.4c0-.607.14-.934 1.12-.934H15V5z" fill="#4267B2" fill-rule="evenodd"/>
            </svg></div>
              <div class="social-media-icons_topic-detail-list-item" [matTooltip]="'SHARE_ON_LINKEDIN' | translate" [matTooltipPosition]="'above'" [matTooltipClass]="'social-media-tooltips'"><svg (click)="socialSharing('https://www.linkedin.com/sharing/share-offsite/?url='+topicURL)" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zM8.342 9.65c-.662.007-1.331.007-1.993 0-.126 0-.168.035-.168.168v7.091c0 .133.035.168.16.168.67-.007 1.34-.007 2.001 0 .126 0 .168-.035.168-.16-.007-1.183-.007-2.365-.007-3.546V9.762c-.008-.082-.05-.112-.16-.112zm7.348.091a3.189 3.189 0 0 0-2.085-.175 2.42 2.42 0 0 0-1.464 1.035c0-.258-.007-.524 0-.783.007-.119-.034-.168-.16-.168-.641.007-1.283.007-1.924 0-.111 0-.16.035-.16.161.007 2.37.007 4.741 0 7.105 0 .126.042.16.16.16a96.74 96.74 0 0 1 2.015 0c.118 0 .153-.034.153-.16a274.363 274.363 0 0 1 0-3.37c0-.28.021-.56.049-.833.042-.307.132-.587.348-.818.265-.294.62-.363.997-.357.537.014.865.26 1.018.77.098.328.105.664.105 1v3.594c0 .168.007.175.167.175h2.028c.14-.003.14-.025.14-.203l-.021-4.35a4.91 4.91 0 0 0-.188-1.314c-.181-.658-.53-1.189-1.178-1.469zm-8.352-3.74C6.544 6.006 6.007 6.642 6 7.35c0 .734.606 1.356 1.345 1.35.76-.008 1.346-.581 1.346-1.35 0-.784-.6-1.357-1.353-1.35z" fill="#2867B2" fill-rule="evenodd"/>
            </svg></div>
              <div class="social-media-icons_topic-detail-list-item" [matTooltip]="'EMAIL_TO_A_FRIEND' | translate" [matTooltipPosition]="'above'" [matTooltipClass]="'social-media-tooltips'"><svg class="social-vnc-icon" (click)="shareViaEmail('mailto:?subject= Check out this amazing topic '+ topic?.subject + ' by ' + topic?.author?.name  + ' at VNC '+ topicURL +'&amp;body= Check out this amazing topic '+ topic?.subject + ' by ' + topic?.author?.name +  ' at VNC '+ topicURL)" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h14zm.774 2.367-5.653 5.654a3 3 0 0 1-4.242 0L4.226 6.367a.995.995 0 0 0-.22.516L4 7v10a1 1 0 0 0 .883.993L5 18h14a1 1 0 0 0 .993-.883L20 17V7c0-.24-.085-.46-.226-.633zM17.314 6H6.685l4.608 4.607a1 1 0 0 0 1.327.077l.087-.077L17.314 6z" fill="#8B96A0" fill-rule="nonzero"/>
            </svg></div>
              <div class="social-media-icons_topic-detail-list-item" [matTooltip]="'COPY_LINK' | translate" [matTooltipPosition]="'above'" [matTooltipClass]="'social-media-tooltips'"><svg class="social-vnc-icon" (click)="copyTopicLink(item)" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 5c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2zm0 2H8v14h11V7zm-4.064-5a1 1 0 0 1 .117 1.993L14.936 4H7.333c-1.235 0-2.246.96-2.328 2.174L5 6.334v11.683a1 1 0 0 1-1.993.116L3 18.017V6.333a4.333 4.333 0 0 1 4.123-4.328L7.333 2h7.603z" fill="#8B96A0" fill-rule="nonzero"/>
            </svg></div>
            </div>
          </div>

      </div>
      <div *ngIf="!noAccess && !topic?.comments_disabled" class="topic-detail_comments">
        <vp-comments [topicId]="topicId" [comment_count]="topic?.comments_count !== null ? topic.comments_count : 0" [focusOnCreation]="focusToCommentArea" (onFormClear)="onCommentFormClear()" (enableDisableComments)="enableDisableComments()" ></vp-comments>
        <vnc-spinner [size]="'xs'" *ngIf="commentsLoading"></vnc-spinner>
      </div>
      <div *ngIf="!noAccess && topic?.comments_disabled" class="disabled-comment">
        <button class="setting-icon" mat-icon-button [matMenuTriggerFor]="menu" [disabled]="topic.author.id !== currentUser.id">
          <ng-container [ngTemplateOutlet]="settingIconTemplate"></ng-container>
        </button>
        <mat-menu class="comment-enable-disable-button" #menu="matMenu">
          <ng-container *ngIf="enableTemplate"
            [ngTemplateOutlet]="enableTemplate">
          </ng-container>
        </mat-menu>
          <!-- <span class="disable-text">{{ 'COMMENTS_DISABLE_MSG' | translate }}</span> -->
          <vnc-empty-state [hasIcon]="false" description="{{ 'COMMENTS_DISABLE_MSG' | translate }}"></vnc-empty-state>
      </div>
      </div>
  </div>
</div>

<ng-template #enableTemplate>
  <div class="item-drop-down">
    <vp-dropdown-item [itemType]="'icon-drop-default'"
                      [prefixIconTemplate]="deleteIconTemplate"
                      label="{{'ENABLE_COMMENT' | translate }}"
                      (onClickEvent)="enableDisableComments($event)">
    </vp-dropdown-item>
  </div>
</ng-template>

<ng-template #removeTagTemplate>
  <div class="item-drop-down">
    <vp-dropdown-item [itemType]="'icon-drop-default'"
                      (onClickEvent)="removeAllTags()"
                      [prefixIconTemplate]="deleteIconTemplate"
                      label="{{'REMOVE_ALL' | translate}}">
    </vp-dropdown-item>
  </div>
</ng-template>
<ng-template #infoImage>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.INFO_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #editTopicImg>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.EDIT_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #attachSVGIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.ATTACH_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #copyLinkIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.COPY_LINK_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #subscribeIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.SUBSCRIBE_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #readIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.READ_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #sendToIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.SEND_TO_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #moveIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.MOVE_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #archiveIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.ARCHIVE_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #unArchiveIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.UN_ARCHIVE_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #deleteIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.DELETE_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #shareIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.SHARE_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #eyeOffImg>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.EYE_OFF_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #menuTemplate let-item="item">
    <div class="item-drop-down">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="showTopicInfo(item)" [prefixIconTemplate]="infoImage" label="{{'TOPIC_INFO' | translate }}">
        </vp-dropdown-item>
      </div>

    <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="editTopic()" [prefixIconTemplate]="editTopicImg" label="{{'EDIT_TOPIC_LABEL' | translate }}">
        </vp-dropdown-item>
      </div>
      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !topic?.is_draft && !topic?.is_scheduled && getPermission(selectedChannel?.permissions, 'moderate_channel')">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="cloneTopic()" [prefixIconTemplate]="cloneIcon" label="{{'COPY_TOPIC' | translate }}">
        </vp-dropdown-item>
      </div>
      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted  && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable">
        <vp-dropdown-item [itemType]="'icon-drop-default'" (onClickEvent)="newFile.click()" [prefixIconTemplate]="attachSVGIcon" label="{{'ADD_FILES' | translate }}">
        </vp-dropdown-item>
        <input  type="file" style="width: 100%;height: 0%;opacity: 0;position: absolute"
        #newFile
        (click)="newFile.value = null" multiple
        (change)="addFileToTopic(newFile.files, item)">
      </div>

      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !topic?.is_draft && !topic?.is_scheduled">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="copyTopicLink(item)" [prefixIconTemplate]="copyLinkIcon" label="{{'COPY_LINK' | translate }}">
        </vp-dropdown-item>
      </div>

      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !item?.subscribed && !topic?.is_draft && !topic?.is_scheduled && !getPermission(item?.permissions, 'read_only')">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="subscribeTopic(item)" [prefixIconTemplate]="subscribeIcon" label="{{'SUBSCRIBE_TO_THE_TOPIC' | translate }}">
        </vp-dropdown-item>
      </div>

      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !!item && item?.subscribed && !topic?.is_draft && !topic?.is_scheduled">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="unsubscribeTopic(item)" [prefixIconTemplate]="subscribeIcon" label="{{'UNSUBSCRIBE_FROM_THE_TOPIC' | translate }}">
        </vp-dropdown-item>
      </div>

      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && (!!item && !item?.read) && !topic?.is_draft && !topic?.is_scheduled">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="readTopic(item)" [prefixIconTemplate]="readIcon" label="{{'MARK_AS_READ' | translate }}">
        </vp-dropdown-item>
      </div>

      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !!item && item?.read && !topic?.is_draft && !topic?.is_scheduled">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="unreadTopic(item)" [prefixIconTemplate]="eyeOffImg" label="{{'MARK_AS_UNREAD' | translate }}">
        </vp-dropdown-item>
      </div>

      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !topic?.is_draft && !topic?.is_scheduled">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="openSendTopicLinkPopup(item)" [prefixIconTemplate]="sendToIcon" label="{{'SEND_TO' | translate }}">
        </vp-dropdown-item>
      </div>
      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable && !topic?.is_draft && !topic?.is_scheduled">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="openMoveToChannelDialog(item)" [prefixIconTemplate]="moveIcon" label="{{'MOVE_TO_CHANNEL' | translate }}">
        </vp-dropdown-item>
      </div>

      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable && !topic?.is_draft && !topic?.is_scheduled">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="openCloneToChannelDialog(item)" [prefixIconTemplate]="cloneIcon" label="{{'COPY_TO_CHANNEL' | translate }}">
        </vp-dropdown-item>
      </div>

      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable && !topic?.is_draft && !topic?.is_scheduled">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="archiveTopic(item)" [prefixIconTemplate]="archiveIcon" label="{{'ARCHIVE_TOPIC' | translate }}">
        </vp-dropdown-item>
      </div>

      <div class="item-drop-down" *ngIf="topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable && !topic?.is_draft && !topic?.is_scheduled">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="unarchiveTopic(item)" [prefixIconTemplate]="unArchiveIcon" label="{{'UNARCHIVE_TOPIC' | translate }}">
        </vp-dropdown-item>
      </div>
      <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[0] && item?.permissions[0]?.deletable">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="deleteTopic(item, true)" [prefixIconTemplate]="deleteIcon" label="{{'MOVE_TO_TRASH' | translate }}">
        </vp-dropdown-item>
      </div>
      <div class="item-drop-down" *ngIf="topic?.deleted && !!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[0] && item?.permissions[0]?.deletable">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="restoreTopic(item)" [prefixIconTemplate]="restoreIcon" label="{{'RESTORE_TOPIC' | translate }}">
        </vp-dropdown-item>
      </div>
      <div class="item-drop-down" *ngIf="topic?.deleted && !!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[0] && item?.permissions[0]?.deletable">
        <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="deleteTopic(item)" [prefixIconTemplate]="deleteIcon" label="{{'DELETE_TOPIC_COMPLETELY' | translate }}">
        </vp-dropdown-item>
      </div>
      <div class="item-drop-down" *ngIf="topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[0] && item?.permissions[0]?.deletable">
        <vp-dropdown-item [itemType]="'icon-drop-default'" (onClickEvent)="permanentlyDeleteTopic(item)"
          [prefixIconTemplate]="deleteIcon" label="{{'DELETE_TOPIC_COMPLETELY' | translate }}">
        </vp-dropdown-item>
      </div>
      <div class="related-topics" (click)="$event.preventDefault(); $event.stopPropagation();">
        <vp-related-topics-list [view]="relatedTopicView.LIST_DROPDOWN"
                                [editable]="topic?.permissions && topic?.permissions?.length > 0 && topic?.permissions[1] && topic?.permissions[1]?.editable"
                                [relatedTopics]="topic?.related_topics"
                                (removeTopics)="onRemoveRelatedTopics($event)"
                                (sendTopics)="onSendRelatedTopics($event)">
        </vp-related-topics-list>
      </div>

</ng-template>

<ng-template #menuTopicDetailTemplate let-item="item">

  <div class="item-drop-down">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="showTopicInfo(item)" [prefixIconTemplate]="infoImage" label="{{'TOPIC_INFO' | translate }}">
    </vp-dropdown-item>
  </div>

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="editTopic()" [prefixIconTemplate]="editTopicImg" label="{{'EDIT_TOPIC_LABEL' | translate }}">
    </vp-dropdown-item>
  </div>

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable">
    <vp-dropdown-item [itemType]="'icon-drop-default'" (onClickEvent)="newFile.click()" [prefixIconTemplate]="attachSVGIcon" label="{{'ADD_FILES' | translate }}">
    </vp-dropdown-item>
    <input type="file" style="width: 100%;height: 0%;opacity: 0;position: absolute"
        #newFile
        (click)="newFile.value = null" multiple
        (change)="addFileToTopic(newFile.files, item)">
  </div>

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="copyTopicLink(item)" [prefixIconTemplate]="copyLinkIcon" label="{{'COPY_LINK' | translate }}">
    </vp-dropdown-item>
  </div>

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && (!!item && !item.read)">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="readTopic(item)" [prefixIconTemplate]="readIcon" label="{{'MARK_AS_READ' | translate }}">
    </vp-dropdown-item>
  </div>

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !!item && item.read">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="unreadTopic(item)" [prefixIconTemplate]="eyeOffImg" label="{{'MARK_AS_UNREAD' | translate }}">
    </vp-dropdown-item>
  </div>

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="openSendTopicLinkPopup(item)" [prefixIconTemplate]="sendToIcon" label="{{'SEND_TO_DOT' | translate }}">
    </vp-dropdown-item>
  </div>
  <div class="item-drop-down" *ngIf="isCordovaApp">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="shareTopic(item)" [prefixIconTemplate]="shareIcon" label="{{'SHARE' | translate }}">
    </vp-dropdown-item>
  </div>

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !!item && !item.subscribed && !getPermission(item?.permissions, 'read_only')">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="subscribeTopic(item)" [prefixIconTemplate]="subscribeIcon" label="{{'SUBSCRIBE_TO_THE_TOPIC' | translate }}">
    </vp-dropdown-item>
  </div>
  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !!item && item.subscribed">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="unsubscribeTopic(item)" [prefixIconTemplate]="subscribeIcon" label="{{'UNSUBSCRIBE_FROM_THE_TOPIC' | translate }}">
    </vp-dropdown-item>
  </div>

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="openMoveToChannelDialog(item)" [prefixIconTemplate]="moveIcon" label="{{'MOVE_TO_CHANNEL' | translate }}">
    </vp-dropdown-item>
  </div>

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted &&!!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="openCloneToChannelDialog(item)" [prefixIconTemplate]="cloneIcon" label="{{'CLONE_TO_CHANNEL' | translate }}">
    </vp-dropdown-item>
  </div>

  <hr style="width: 95vw;margin: 1em auto;" *ngIf="!topic?.archived && !topic?.deleted && !!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable" />

  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="archiveTopic(item)" [prefixIconTemplate]="archiveIcon" label="{{'ARCHIVE_TOPIC' | translate }}">
    </vp-dropdown-item>
  </div>
  <div class="item-drop-down" *ngIf="topic?.archived && !topic?.deleted && !!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[1] && item?.permissions[1]?.editable">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="unarchiveTopic(item)" [prefixIconTemplate]="unArchiveIcon" label="{{'UNARCHIVE_TOPIC' | translate }}">
    </vp-dropdown-item>
  </div>
  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[0] && item?.permissions[0]?.deletable">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="deleteTopic(item, true)" [prefixIconTemplate]="deleteIcon" label="{{'MOVE_TO_TRASH' | translate }}">
    </vp-dropdown-item>
  </div>
  <div class="item-drop-down" *ngIf="topic?.deleted && !!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[0] && item?.permissions[0]?.deletable">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="restoreTopic(item)" [prefixIconTemplate]="restoreIcon" label="{{'RESTORE_TOPIC' | translate }}">
    </vp-dropdown-item>
  </div>
  <div class="item-drop-down" *ngIf="topic?.deleted && !!item && item?.permissions && item?.permissions?.length > 0 && item?.permissions[0] && item?.permissions[0]?.deletable">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="deleteTopic(item)" [prefixIconTemplate]="deleteIcon" label="{{'DELETE_TOPIC_COMPLETELY' | translate }}">
    </vp-dropdown-item>
  </div>
  <div class="item-drop-down" *ngIf="!topic?.archived && !topic?.deleted && !topic?.is_draft && !topic?.is_scheduled && getPermission(selectedChannel?.permissions, 'create_topics')">
    <vp-dropdown-item [itemType]="'icon-drop-default'"  (onClickEvent)="cloneTopic()" [prefixIconTemplate]="cloneIcon" label="{{'CLONE_TOPIC_HEADER' | translate }}">
    </vp-dropdown-item>
  </div>
  <div class="item-drop-down" *ngIf="topic?.archived && !topic?.deleted && item?.permissions && item?.permissions?.length > 0 && item?.permissions[0] && item?.permissions[0]?.deletable">
    <vp-dropdown-item [itemType]="'icon-drop-default'" (onClickEvent)="permanentlyDeleteTopic(item)"
      [prefixIconTemplate]="deleteIcon" label="{{'DELETE_TOPIC_COMPLETELY' | translate }}">
    </vp-dropdown-item>
  </div>


</ng-template>

<ng-template #cloneIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.COPY_LINK_ICON"></vp-channel-detail-icon>
</ng-template>

<ng-template #scheduleIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.SCHEDULE_ICON"></vp-channel-detail-icon>
</ng-template>

<ng-template #editIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.EDIT_ICON"></vp-channel-detail-icon>
</ng-template>
<ng-template #editIconWhite>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <g fill="none" fill-rule="evenodd">
      <g fill="#fff">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path d="M0 10.688V13.5h2.813l8.294-8.295-2.812-2.813L0 10.688zM13.283 3.03c.292-.292.292-.765 0-1.057L11.527.216c-.293-.292-.766-.292-1.058 0L9.097 1.59l2.813 2.813 1.373-1.373z" transform="translate(-315 -433) translate(0 338) translate(12 72) translate(300 20) translate(3 3) translate(2.25 2.25)"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #deleteIconTemplate>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/delete-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path d="M18,7 L18,18.2857143 C18,19.7746499 16.8086874,21 15.3333333,21 L15.3333333,21 L8.66666667,21 C7.19131256,21 6,19.7746499 6,18.2857143 L6,18.2857143 L6,7 L18,7 Z M16,9 L8,9 L8,18.2857143 C8,18.649428 8.25938319,18.9465317 8.57834889,18.9935231 L8.57834889,18.9935231 L8.66666667,19 L15.3333333,19 C15.6913126,19 16,18.6824929 16,18.2857143 L16,18.2857143 L16,9 Z M13,3 C13.7404864,3 14.3869825,3.40242038 14.7327215,4.00049436 L18,4 C18.5522847,4 19,4.44771525 19,5 C19,5.55228475 18.5522847,6 18,6 L6,6 C5.44771525,6 5,5.55228475 5,5 C5,4.44771525 5.44771525,4 6,4 L9.26760632,3.99992752 C9.61342606,3.40216612 10.2597476,3 11,3 L13,3 Z" id="Combined-Shape" fill="#8B96A0"></path>
    </g>
  </svg>
</ng-template>

<ng-template #editIconRed>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <g fill="none" fill-rule="evenodd">
      <g fill="#fff">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path d="M0 10.688V13.5h2.813l8.294-8.295-2.812-2.813L0 10.688zM13.283 3.03c.292-.292.292-.765 0-1.057L11.527.216c-.293-.292-.766-.292-1.058 0L9.097 1.59l2.813 2.813 1.373-1.373z" transform="translate(-315 -433) translate(0 338) translate(12 72) translate(300 20) translate(3 3) translate(2.25 2.25)"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<ng-template #relatedTopicsTemplate>
  <vp-related-topics-list
    [view]="relatedTopicView.GRID"
    [editable]="topic?.permissions && topic?.permissions?.length > 0 && topic?.permissions[1] && topic?.permissions[1]?.editable"
    [relatedTopics]="topic?.related_topics"
    [topicId]="selfTopicId"
    (newTopicAdded)="onNewRelatedTopicAdded($event)"
    (removeTopics)="onRemoveRelatedTopics($event)"
    (sendTopics)="onSendRelatedTopics($event)">
  </vp-related-topics-list>
</ng-template>

<ng-template #emptyStateIconTemplate>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.EMPTY_STATE_ICON"></vp-channel-detail-icon>
</ng-template>

<ng-template #restoreIcon>
  <vp-channel-detail-icon [iconName]="channelDetailIconName.RESTORE_ICON"></vp-channel-detail-icon>
</ng-template>

<ng-template #bannerCloneIcon>

  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <g fill="none" fill-rule="evenodd">
      <g fill="#FFF">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="M12 2.25c.825 0 1.5.675 1.5 1.5v10.5c0 .825-.675 1.5-1.5 1.5H3.75c-.825 0-1.5-.675-1.5-1.5V3.75c0-.825.675-1.5 1.5-1.5zm0 1.5H3.75v10.5H12V3.75zM8.952 0c.414 0 .75.336.75.75 0 .385-.29.702-.663.745l-.087.005H3.25c-.926 0-1.684.72-1.746 1.63l-.004.12v8.762c0 .415-.336.75-.75.75-.385 0-.702-.29-.745-.662L0 12.012V3.25C0 1.508 1.37.086 3.093.004L3.25 0h5.702z"
                    transform="translate(-1163.000000, -109.000000) translate(335.000000, 100.000000) translate(783.000000, 6.000000) translate(42.000000, 0.000000) translate(3.000000, 3.000000) translate(2.250000, 1.500000)" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>

</ng-template>

<ng-template #settingIconTemplate>
	<svg width="20px" height="20px" viewBox="0 0 24 24">
        <g id="Icon/product/wrench-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M10.0217391,2 C13.9304035,2 16.2827353,4.66518354 16.3876405,7.31517522 L16.3911337,7.56339088 L16.3676338,8.53663925 C16.3606999,9.16323493 16.3960107,9.55409723 16.5074632,9.97521537 C16.679656,10.6258374 17.0258245,11.154374 17.636458,11.6038735 L20.9596441,14.0677107 L22.5985641,15.2898342 C23.0409855,15.620412 23.1316527,16.2470517 22.8010749,16.6894732 C22.4959262,17.0978622 21.9385117,17.2065316 21.5065847,16.9608251 L21.3496148,16.8532709 L17.6650017,14.111669 L16.4506562,13.2144244 C15.4624139,12.4869595 14.8598864,11.5670093 14.5740302,10.486915 C14.4098135,9.86643026 14.3602025,9.3410047 14.3669641,8.57035905 L14.3913043,7.5 C14.3913043,5.82931736 12.8376939,4 10.0217391,4 C9.50237748,4 9.03597117,4.01268367 8.61994888,4.0362932 L8.279,4.059 L9.32701123,4.58716777 L10.0813305,4.98237802 C12.1100883,6.0704377 12.0119258,8.02920703 10.8951792,10.0323862 C9.82564973,11.950869 8.38011231,12.9567024 6.33326313,12.105098 L5.36903499,11.6960201 L4.447,11.293 L4.52313928,11.4815155 C4.60353707,11.6692078 4.69284267,11.8544843 4.79148251,12.0361587 L4.94649625,12.3058204 C5.26549307,12.8305199 5.65513393,13.2959633 6.12281505,13.6899868 C6.95781755,14.3939281 8.23574853,14.6818182 10.4347826,14.6818182 C11.5721448,14.6818182 12.7012452,15.0361297 13.7864056,15.6190591 C14.0696483,15.7712122 14.323559,15.923745 14.5401232,16.0646797 L14.8359578,16.2658861 L15.0697617,16.4407119 L15.1615237,16.5154248 L20.1180455,20.197243 C20.5613959,20.5265739 20.653827,21.1529559 20.3244961,21.5963063 C20.0204984,22.0055529 19.463392,22.1157913 19.030775,21.8713018 L18.9254328,21.802757 L13.9247097,18.0861336 L13.7946317,17.9853011 L13.6489564,17.8800745 C13.4080605,17.7104101 13.1356612,17.5397902 12.8399531,17.3809409 C12.0212412,16.9411431 11.1948389,16.6818182 10.4347826,16.6818182 C7.80557497,16.6818182 6.11772206,16.3015815 4.83394648,15.2193062 C4.19442042,14.6805026 3.66541482,14.0485818 3.2375418,13.3447982 C2.39070119,11.951879 2.05780289,10.5721392 2.00167394,9.60329127 C1.95801501,8.84968956 2.73312652,8.32128128 3.41865422,8.63730883 L4.25773628,9.01886939 C4.68195106,9.21005038 5.11118536,9.40120943 5.53376071,9.58658104 L6.47517918,9.99434992 L7.10152642,10.2585413 C7.93137037,10.6038031 8.51209408,10.1997241 9.14829903,9.05852294 C9.79012993,7.90723015 9.82973558,7.11692512 9.13606078,6.74489471 L8.66730845,6.49753671 L7.81761443,6.06390199 C7.41509592,5.86181122 6.99285442,5.65376503 6.56398808,5.44546362 L5.05452265,4.72396652 C4.56204943,4.49358095 4.34388115,3.91193704 4.56335853,3.41450657 C4.7358943,3.02346604 5.15948736,2.69591403 5.86507525,2.46049686 C6.7480699,2.1658885 8.09327616,2 10.0217391,2 Z" id="Stroke-28" fill="#2c7abf">
            </path>
        </g>
	</svg>
</ng-template>
<ng-template #unmuteIconBlack>
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.492 15.758c0 .787-.608 1.431-1.38 1.488L9 17.25a1.492 1.492 0 0 1-1.488-1.381l-.004-.111h2.984zm-5.9-11.576L14.67 14.258a.748.748 0 0 1 .154.224l.084.086a.766.766 0 0 0 .008.008.466.466 0 0 1-.04.072.75.75 0 0 1-1.267.67L13.29 15H3.398A.397.397 0 0 1 3 14.602c0-.26.064-.518.186-.748l.654-1.239V8.25c0-.79.177-1.537.494-2.206l-.802-.802a.75.75 0 1 1 1.06-1.06zm.752 3.898-.004.17.004 4.25a1 1 0 0 0 1 1h5.316c.042 0 .082-.003.123-.007l-6.29-6.29c-.084.28-.135.575-.15.877zM9 1.5a1.19 1.19 0 0 1 1.188 1.084l.005.108v.54a5.156 5.156 0 0 1 3.964 4.826l.003.192v3.45l-1.501-1.501.001-1.949a3.655 3.655 0 0 0-2.65-3.515l-.163-.043a4.253 4.253 0 0 0-1.694 0c-.26.062-.507.15-.74.262L6.31 3.849a5.147 5.147 0 0 1 1.319-.57l.179-.046v-.54A1.19 1.19 0 0 1 8.89 1.504L9 1.5z" fill="#000" fill-rule="evenodd"/>
</svg>
</ng-template>
<ng-template #muteIconBlack>
  <svg width="18" height="18" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.99 21.212c0 1.05-.81 1.909-1.841 1.985l-.149.005c-1.05 0-1.909-.81-1.985-1.841l-.005-.149h3.98zM12 2.202c.831 0 1.51.633 1.584 1.445l.006.145v.72a6.874 6.874 0 0 1 5.285 6.435l.005.255v5.82l.392.392c.466.466.728 1.099.728 1.758a1.03 1.03 0 0 1-1.03 1.03H4.53a.53.53 0 0 1-.53-.53c0-.348.085-.69.248-.999l.872-1.65v-5.82a6.873 6.873 0 0 1 5.052-6.63l.238-.06v-.72c0-.832.633-1.511 1.445-1.584L12 2.202zm0 4.142c-.376 0-.753.038-1.13.114a4.873 4.873 0 0 0-3.745 4.518l-.005.226.005 6a1 1 0 0 0 1 1h7.755a1 1 0 0 0 1-1v-6a4.873 4.873 0 0 0-3.534-4.687l-.217-.057A5.671 5.671 0 0 0 12 6.344z" fill="#000" fill-rule="evenodd"/>
</svg>

</ng-template>